import { render, staticRenderFns } from "./PasswordResetButton.vue?vue&type=template&id=e4f6f9da"
import script from "./PasswordResetButton.vue?vue&type=script&lang=ts"
export * from "./PasswordResetButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports